"use strict";
/* eslint-disable no-dupe-keys */
module.exports = {
    entitySettlement: 'Underlag till avräkning' || 'entitySettlement',
    upsertManualEntitySettlement: 'Skapa/ändra manuellt underlag' || 'upsertManualEntitySettlement',
    createEntitySettlementFromOrderCorrection: 'Skapa specialjusteringar' || 'createEntitySettlementFromOrderCorrection',
    cancel: 'Makulera' || 'cancel',
    ensureBasedOnOrder: 'Skapa avräkningsunderlag baserat på order' || 'ensureBasedOnOrder',
    ensureBasedOnComplaint: 'Skapa avräkningsunderlag baserat på reklamation' ||
        'ensureBasedOnComplaint',
    ensureBasedOnPurchaseOrder: 'Skapa avräkningsunderlag baserat på inköpsorder' ||
        'ensureBasedOnPurchaseOrder',
    ensureMonthlyFeeEntitySettlement: 'Skapa månadsavgiftsunderlag' || 'ensureMonthlyFeeEntitySettlement',
    linkToSettlement: 'Länka till avräkning' || 'linkToSettlement',
    upsert: '' || 'upsert',
    upsertWhenEmpty: '' || 'upsertWhenEmpty',
    updateWhenEmpty: '' || 'updateWhenEmpty',
    update: '' || 'update',
    id: 'Identitet' || 'id',
    entityType: 'Entitetstyp' || 'entityType',
    entityTypes: {
        order: 'Order' || 'order',
        purchaseOrder: 'inköpsorder' || 'purchaseOrder',
        complaint: 'Reklamation' || 'complaint',
        manual: 'Manuell rad' || 'manual',
        alcoholTaxAdjustment: 'Alkoholskattesjustering' || 'alcoholTaxAdjustment',
        monthlyFee: 'Månadsavgift' || 'monthlyFee',
    },
    entityId: 'Entitetsid' || 'entityId',
    entity: 'Entitet' || 'entity',
    cancelled: 'makulerad' || 'cancelled',
    copackAgreement: 'Copackningsavtal' || 'copackAgreement',
    orderBrokerageAgreement: 'Orderförmedlaravtal' || 'orderBrokerageAgreement',
    agreementDetails: 'Detaljer' || 'agreementDetails',
    settlementDate: 'Avräkningsdatum' || 'settlementDate',
    settlement: 'Avräkning' || 'settlement',
    supplierOrganizationId: 'leverantörsorganisationsid' || 'supplierOrganizationId',
};
